import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { IDataGrouped } from '@app/interfaces/idata-grouped';

@Component({
  selector: 'filter-tag-checkbox-level',
  templateUrl: './filter-tag-checkbox-level.component.html',
  styleUrls: ['./filter-tag-checkbox-level.component.css']
})
export class FilterTagCheckboxLevelComponent {

  @Input() controlArray: FormArray;
  @Input() label: string = '';
  @Input() dataSelect: Array<IDataGrouped> = [];

  constructor() { }

  onRemoveOption(indexParent: number, indexChild: number) {

    const faParent = this.controlArray.at(indexParent) as FormArray;

    faParent.at(indexChild).setValue(false);
  }
}
